import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from './messages';

const RateProvidedLabel = () => <FormattedMessage {...messages.rateProvidedLabel} />;

export default RateProvidedLabel;
